import { getIdInformationQueryRequest } from '@/services/eas-service/profile';
import { useQuery } from '@umijs/max';

const GetUserProfileKey = 'GetUserProfileKey';

export const useGetUserProfileQuery = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [GetUserProfileKey],
    queryFn: async () => await getIdInformationQueryRequest(),
    enabled: options?.enabled ?? false,
  });
};
